import { useState } from "react";
import { Facebook, Instagram, Twitter, Menu, X } from "react-feather";
import { Link } from "react-router-dom";
import styles from "./Modernminimaltemplate.module.css";

const ModernMinimalTemplate = ({ data, isStickyHeader }) => {
    const [isNavOpen, setIsNavOpen] = useState(false);

    const closeNav = () => setIsNavOpen(false);

    return (<div className={styles.page}>
        <div className={styles.wrapper}>
            <header className={`${styles.header} ${isStickyHeader ? styles.headerSticky : styles.headerStatic}`}>
                <div className={styles.logo}>
                    <img src={data && data?.logoURL ? data?.logoURL : "/images/logo.svg"} alt="logo" />
                </div>

                <nav className={`${styles.nav} ${isNavOpen ? styles.navOpen : ""}`}>
                    <button type="button" className={styles.menuToggle} aria-label="Close menu" onClick={closeNav} style={{ display: isNavOpen ? "inline-flex" : "none", alignSelf: "flex-end" }}>
                        <X size={26} />
                    </button>

                    <Link to={"/add-booking"} className={styles.navLink} onClick={closeNav}>Make A Booking</Link>
                    <Link to={"/contact-us"} className={styles.navLink} onClick={closeNav}>Contact Us</Link>
                    <Link to={"/sign-in"} className={styles.navLink} onClick={closeNav}>Sign In</Link>
                    <Link to={"/track-booking"} className={styles.navLink} onClick={closeNav}>Track</Link>
                    <button className={styles.phoneBtn}>{data && data?.phone ? data?.phone : ""}</button>
                </nav>

                <button type="button" className={styles.menuToggle} aria-label="Open menu" onClick={() => setIsNavOpen(true)}>
                    <Menu size={26} />
                </button>
            </header>

            <section className={styles.hero}>
                <div>
                    <p className={styles.heroEyebrow}>{data && data?.heroTitle ? data?.heroTitle : ""}</p>
                    <h1 className={styles.heroTitle}>{data && data?.heroSubTitle ? data?.heroSubTitle : ""}</h1>
                    <p className={styles.heroDescription}>{data && data?.heroDescription ? data?.heroDescription : ""}</p>
                </div>

                <div>
                    <img src={data?.bannerImage ? data.bannerImage : "/images/template3-banner.png"} alt="truck" className={styles.heroImage} />
                </div>
            </section>

            <section className={styles.servicesSection}>
                <div className={styles.servicesGrid}>
                    {(data?.services || []).map((item, index) => (<div key={index} className={styles.serviceCard}>
                        <div className={styles.serviceIcon}>
                            <img src={item?.icon} alt="icon" />
                        </div>
                        <h3 className={styles.serviceCardTitle}>{item.title}</h3>
                        <p className={styles.serviceCardDescription}>{item.description}</p>
                    </div>))}
                </div>
            </section>

            <section className={styles.aboutSection}>
                <div>
                    <h2 className={styles.aboutTitle}>{data && data?.aboutTitle ? data?.aboutTitle : ""}</h2>
                    <div className={styles.aboutDescription}>{data && data?.aboutDescription ? data?.aboutDescription : ""}</div>
                </div>

                <div>
                    <img src={data && data?.aboutImage ? data?.aboutImage : "/images/template3-image.png"} alt="warehouse" className={styles.aboutImage} />
                </div>
            </section>
        </div>

        <footer className={styles.footer}>
            <div className={styles.footerTop}>
                <div>
                    <h3 className={styles.footerHeading}>Contact Info</h3>
                    <p>📞 {data && data?.phone ? data?.phone : ""}</p>
                    <p>✉️ {data && data?.email ? data?.email : "admin@eflogistics.io"}</p>
                    <p>📍 {data && data?.address ? data?.address : ""}</p>
                </div>

                <div>
                    <h3 className={styles.footerHeading}>Follow Us</h3>
                    <div className={styles.socialRow}>
                        <Link to={data && data?.facebookURL ? data?.facebookURL : "/"} target="_blank" className={styles.socialIcon}>
                            <Facebook />
                        </Link>
                        <Link to={data && data?.instagramURL ? data?.instagramURL : "/"} target="_blank" className={styles.socialIcon}>
                            <Instagram />
                        </Link>
                        <Link to={data && data?.twitterURL ? data?.twitterURL : "/"} target="_blank" className={styles.socialIcon}>
                            <Twitter />
                        </Link>
                    </div>
                </div>
            </div>

            <div className={styles.copyright}>{data && data?.copyRightText ? data?.copyRightText : ""}</div>
        </footer>
    </div>);
};

export default ModernMinimalTemplate;